import InfoIcon from "@mui/icons-material/Info";
import {Box, Popover} from "@mui/material";
import {useState} from "react";
import {Trans} from "react-i18next";

interface Props {
    i18nKey: string;
    placement?: "top" | "bottom" | "center";
    direction?: "left" | "right";
}

export const HelpPopover: React.FC<Props> = (props: Props) => {
    const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null);

    const open = Boolean(anchorEl);

    const vertical = props.placement ?? "top";
    const horizontal = props.direction === "right" ? "left" : "right";

    const handlePopoverOpen = (event: React.MouseEvent<HTMLElement>) => {
        setAnchorEl(event.currentTarget);
    };

    const handlePopoverClose = () => {
        setAnchorEl(null);
    };

    const width = Math.max(window.innerWidth * 0.2, 350);

    return (
        <>
            <Popover
                sx={{opacity: "100%", pointerEvents: "none"}}
                elevation={4}
                id={props.i18nKey}
                open={open}
                anchorOrigin={{
                    vertical,
                    horizontal,
                }}
                anchorEl={anchorEl}
                transformOrigin={{
                    vertical: getTransformOriginVertical(vertical),
                    horizontal: getTransformOriginHorizontal(horizontal, vertical),
                }}
                onClose={handlePopoverClose}
                disableRestoreFocus
                aria-hidden={false}
            >
                <Box
                    sx={{
                        width: `${width}px`,
                        padding: "0.5rem 1rem",
                        borderRadius: "4px",
                        border: "1px solid #BDBDBD",
                        fontSize: "0.95rem",
                    }}
                >
                    <Trans i18nKey={props.i18nKey} />
                </Box>
            </Popover>

            <Box
                sx={{padding: "0.3rem", display: "flex", alignItems: "center"}}
                aria-owns={open ? "mouse-over-popover" : undefined}
                aria-haspopup="true"
                onMouseEnter={handlePopoverOpen}
                onMouseLeave={handlePopoverClose}
            >
                <InfoIcon sx={{color: anchorEl ? "primary.main" : "#BDBDBD"}} />
            </Box>
        </>
    );
};

const getTransformOriginHorizontal = (
    anchorHorizontal: "left" | "right",
    anchorVertical: "top" | "center" | "bottom",
) => {
    if (anchorVertical === "top" || anchorVertical === "bottom") return anchorHorizontal;

    return anchorHorizontal === "left" ? -40 : 40;
};

const getTransformOriginVertical = (anchorVertical: "top" | "center" | "bottom") => {
    switch (anchorVertical) {
        case "top":
            return "bottom";
        case "bottom":
            return "top";
        case "center":
            return "center";
    }
};
